<script setup lang="ts">
import { useTourStore } from '@/stores/components/tour';
import { VTour } from '@globalhive/vuejs-tour';
import { nextTick, useTemplateRef } from 'vue';

const tourStore = useTourStore();

const tour = useTemplateRef('tour');

nextTick(() => {
    tourStore.component = tour.value;
});

const buttonLabels = { done: 'OK', next: 'Volgende', back: 'Terug', skip: 'Sluiten' };
</script>

<template>
    <VTour ref="tour" :steps="tourStore.steps" :hide-skip="tourStore.steps.length === 1" backdrop no-scroll highlight :button-labels="buttonLabels" />
</template>

<style>
#vjt-tooltip {
    background-color: rgb(241 245 249) !important;
    color: var(--c-main-dark) !important;
}

#vjt-arrow::before {
    background-color: rgb(241 245 249) !important;
}

.vjt-actions button {
    border: 1px solid var(--c-main-dark) !important;
    background-color: var(--c-main) !important;
}

.vjt-actions button:hover {
    background-color: var(--c-main-dark) !important;
    color: rgb(241 245 249) !important;
}
</style>
